export const green = "#038C5A";
export const gray = "#d6d7d8";
export const darkgray = "#cccccc";
